class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);


  // Hover para abrir mega menu - Studio theme
document.querySelectorAll('header-menu').forEach(headerMenu => {
  const detail = headerMenu.querySelector('details.mega-menu');
  if (!detail) return;

  const openMenu = () => {
    if (!detail.hasAttribute('open')) {
      detail.setAttribute('open', '');
      const summary = detail.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      detail.dispatchEvent(new Event('toggle'));
    }
    const content = detail.querySelector('.mega-menu__content');
    if (content) {
      content.style.zIndex = '100';
      const detailLeft = detail.getBoundingClientRect().left;
      const headerRect = document.querySelector('.header-wrapper').getBoundingClientRect();
      const offset = detailLeft - headerRect.left;
      content.style.left = `-${offset}px`;
      content.style.width = `${window.innerWidth + offset}px`;
    }
  };

  const closeMenu = () => {
    detail.removeAttribute('open');
    const summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    const content = detail.querySelector('.mega-menu__content');
    if (content) {
      content.style.zIndex = '';
      content.style.left = '';
      content.style.width = '';
    }
  };

  detail.addEventListener('mouseenter', openMenu);

  document.addEventListener('mousemove', (e) => {
    if (!detail.hasAttribute('open')) return;
    const content = detail.querySelector('.mega-menu__content');
    const summaryRect = detail.querySelector('summary').getBoundingClientRect();
    const contentRect = content ? content.getBoundingClientRect() : null;

    const gapTop = summaryRect.top;
    const gapBottom = contentRect ? contentRect.bottom : summaryRect.bottom;
    const gapLeft = contentRect ? contentRect.left : summaryRect.left;
    const gapRight = contentRect ? contentRect.right : summaryRect.right;

    const inSafeZone = e.clientX >= gapLeft && e.clientX <= gapRight &&
                       e.clientY >= gapTop && e.clientY <= gapBottom;

    if (!inSafeZone) closeMenu();
  });
});
